__turbopack_context__.v({
  "bodyLine": "FansHeroIntro-module-scss-module__fq6hXG__bodyLine",
  "challengesLink": "FansHeroIntro-module-scss-module__fq6hXG__challengesLink",
  "challengesText": "FansHeroIntro-module-scss-module__fq6hXG__challengesText",
  "ctaRow": "FansHeroIntro-module-scss-module__fq6hXG__ctaRow",
  "eyebrow": "FansHeroIntro-module-scss-module__fq6hXG__eyebrow",
  "headline": "FansHeroIntro-module-scss-module__fq6hXG__headline",
  "headlineAccent": "FansHeroIntro-module-scss-module__fq6hXG__headlineAccent",
  "headlineWhite": "FansHeroIntro-module-scss-module__fq6hXG__headlineWhite",
  "joinCta": "FansHeroIntro-module-scss-module__fq6hXG__joinCta",
  "joinCtaArrow": "FansHeroIntro-module-scss-module__fq6hXG__joinCtaArrow",
  "joinCtaText": "FansHeroIntro-module-scss-module__fq6hXG__joinCtaText",
});
